import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Style from '../Skeleton.module.scss';

const TextRow = ({ type, className }) => {
  const rowClass = classNames(Style[`textRow${type}`], className);
  return <div className={rowClass} />;
};

TextRow.defaultProps = {
  type: 'Regular',
  className: null,
};

TextRow.propTypes = {
  type: PropTypes.oneOf(['Regular', 'Center', 'Rounded']),
  className: PropTypes.string,
};

export default TextRow;
